import { useEffect, useRef, useState } from "react";
import { createPortal } from 'react-dom';

export type DialogProps = {
    show: boolean,
    width?: number,
    children: React.ReactNode,
    onClose: (close: false) => void,
}

export default function Dialog({ show, width, children, onClose }: DialogProps) {
    const [portal, setPortal] = useState<HTMLElement | null>(null);
    useEffect(() => {
        setPortal(document.getElementById("dialog-portal"));
    }, [show]);

    const dialogRef = useRef<HTMLDivElement>(null);

    // TODO: close only one on Escape
    useEffect(() => {
        if (!show) return;

        const handleEscapePress = (event) => {
            if (event.key === 'Escape')
                onClose(false);
        };

        document.addEventListener('keydown', handleEscapePress);

        return () => {
            document.removeEventListener('keydown', handleEscapePress);
        };
    }, [show]);

    function handleWrapperClick(event) {
        event.stopPropagation();

        if (dialogRef.current && !dialogRef.current.contains(event.target))
            onClose(false);
    }

    if (!portal) return null;

    return createPortal(
        <div className={`dialog-wrapper ${show ? 'show' : ''}`} onClick={handleWrapperClick}>
            <div ref={dialogRef} className="dialog block">
                <div className="dialog-content" style={width ? { width: `${width}px` } : undefined}>
                    {children}
                </div>
            </div>
        </div>,
        portal
    );
}

export function DialogProvider({ children }: { children: React.ReactNode }) {
    return <>
        {children}
        <div id="dialog-portal" />
    </>;
}

/*
const DialogContext = createContext<{ ref: React.RefObject<HTMLDivElement | null> }>({
    ref: { current: null }
});

export function DialogProvider({ children }: { children: React.ReactNode }) {
    const ref = useRef<HTMLDivElement>(null);

    return <DialogContext.Provider value={{ ref }}>
        {children}
        <div ref={ref} id="dialog-portal" />
    </DialogContext.Provider>;
}
*/